/**
 * @generated SignedSource<<9abc37530acaaa68e84240829b9c09b3>>
 * @relayHash 71c94317b822094613bae175c3a66d36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fbaa3ee68b6ac2cd5fd36baecaa22799cd3dbe90afe1df714af04960a657bb74

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type TaskStatus = "CHECKED" | "UNCHECKED" | "%future added value";
export type SetTaskStatusMutation$variables = {
  contentId: string;
  status: TaskStatus;
  taskId: string;
};
export type SetTaskStatusMutation$data = {
  readonly setTaskStatus: {
    readonly success: boolean;
  } | null | undefined;
};
export type SetTaskStatusMutation = {
  response: SetTaskStatusMutation$data;
  variables: SetTaskStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskId"
},
v3 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "cid",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
          },
          {
            "kind": "Variable",
            "name": "taskId",
            "variableName": "taskId"
          },
          {
            "kind": "Literal",
            "name": "trigger",
            "value": "VIEW_PAGE"
          }
        ],
        "kind": "ObjectValue",
        "name": "inlineTasksInput"
      }
    ],
    "concreteType": "GraphQLMutationResponse",
    "kind": "LinkedField",
    "name": "setTaskStatus",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SetTaskStatusMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SetTaskStatusMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "71c94317b822094613bae175c3a66d36",
    "id": "fbaa3ee68b6ac2cd5fd36baecaa22799cd3dbe90afe1df714af04960a657bb74",
    "metadata": {},
    "name": "SetTaskStatusMutation",
    "operationKind": "mutation",
    "text": "mutation SetTaskStatusMutation($contentId:ID!,$taskId:ID!,$status:TaskStatus!){setTaskStatus(inlineTasksInput:{cid:$contentId,taskId:$taskId,status:$status,trigger:VIEW_PAGE}){success}}"
  }
};
})();

(node as any).hash = "b0fcb034a764e654bff661127582f078";

export default node;
